(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advancedslideshow"] && !Shopify.designMode) return;
  try {
    
  // Web Component for completely isolated, vanilla, ultra-fast logic
  class AdvancedSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.slide-item'));
      this.dots = Array.from(this.querySelectorAll('.slideshow__dot'));
      this.prevBtn = this.parentElement.querySelector('.slideshow__arrow--prev');
      this.nextBtn = this.parentElement.querySelector('.slideshow__arrow--next');
      
      this.currentIndex = 0;
      this.isAnimating = false;
      
      // Config mapping from liquid data attributes
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval) || 5000;
      this.animationType = this.dataset.animation || 'slide';
      
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.touchEndX = 0;

      this.init();
    }

    init() {
      if (this.slides.length <= 1) return;

      // Event Listeners
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.navigate('next'));
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.navigate('prev'));
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch events for mobile swipe
      this.addEventListener('touchstart', e => {
        this.touchStartX = e.changedTouches[0].screenX;
        this.pauseAutoplay();
      }, { passive: true });

      this.addEventListener('touchend', e => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
        if (this.autoplay) this.startAutoplay();
      }, { passive: true });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      if (this.autoplay) this.startAutoplay();
      
      // For Shopify Theme Editor compatibility
      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const index = parseInt(event.target.dataset.index);
          this.pauseAutoplay();
          this.goToSlide(index);
        });
      }
    }

    handleSwipe() {
      const swipeThreshold = 50;
      if (this.touchEndX < this.touchStartX - swipeThreshold) this.navigate('next');
      if (this.touchEndX > this.touchStartX + swipeThreshold) this.navigate('prev');
    }

    navigate(direction) {
      if (this.isAnimating) return;
      let nextIndex = direction === 'next' ? this.currentIndex + 1 : this.currentIndex - 1;
      
      if (nextIndex >= this.slides.length) nextIndex = 0;
      if (nextIndex < 0) nextIndex = this.slides.length - 1;
      
      this.goToSlide(nextIndex, direction);
    }

    goToSlide(index, direction = null) {
      if (index === this.currentIndex || this.isAnimating) return;
      this.isAnimating = true;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[index];

      // Determine direction for slide animation logic if not clicked via arrows
      if (!direction) {
        direction = index > this.currentIndex ? 'next' : 'prev';
      }

      // Reset classes
      this.slides.forEach(slide => {
        slide.classList.remove('is-active', 'is-next', 'is-prev');
      });

      // Prepare next slide position
      if (this.animationType === 'slide') {
        nextSlide.classList.add(direction === 'next' ? 'is-next' : 'is-prev');
        // Trigger reflow to ensure the transition fires correctly
        void nextSlide.offsetWidth;
      }

      // Execute transition
      currentSlide.classList.remove('is-active');
      nextSlide.classList.remove('is-next', 'is-prev');
      nextSlide.classList.add('is-active');

      // Update Dots
      if (this.dots.length) {
        this.dots.forEach(dot => dot.classList.remove('is-active'));
        this.dots[index].classList.add('is-active');
      }

      this.currentIndex = index;

      // Unlock animation lock after transition duration
      const transitionDuration = parseFloat(getComputedStyle(this).getPropertyValue('--slide-animation-duration')) * 1000 || 500;
      setTimeout(() => {
        this.isAnimating = false;
      }, transitionDuration);

      // Reset autoplay if running
      if (this.autoplayTimer) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => this.navigate('next'), this.interval);
    }

    pauseAutoplay() {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  // Register the custom element only if not already defined
  if (!customElements.get('advanced-slideshow')) {
    customElements.define('advanced-slideshow', AdvancedSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
